// eslint-disable-next-line
/* global localStorage */
import classNames from 'classnames';
import React, { useEffect, useState, useContext, useRef } from 'react';
import { apiGet, apiPost, apiPut } from '../../../utils/apiFetch';
import apiPath from '../../../utils/apiPath';
import { useLocation, useNavigate } from 'react-router-dom';
import useToastContext from 'hooks/useToastContext';
import { useForm } from 'react-hook-form';
import ErrorMessage from 'components/ErrorMessage';
import { isEmpty, isNumber } from 'lodash';
import OInputField from 'components/reusable/OInputField';
import { useTranslation } from 'react-i18next';
import { TAB_ADDRESS } from '../AddProperty';
import OSelect from 'components/reusable/OSelect';
import formValidation from 'utils/formValidation';
import OAmenities from 'components/reusable/OAmenities';
import OPropertyCategories from 'components/reusable/OPropertyCategories';
import AgentListModal from '../AgentListModal';
import AuthContext from 'context/AuthContext';
import OTextArea from 'components/reusable/OTextArea';
import ODateTimePicker from 'components/shared/datePicker/ODateTimePicker';
import helper from 'utils/helpers';
import ReactQuill from 'react-quill';
import ODatePicker from 'components/shared/datePicker/ODatePicker';
import OMultiSelect from 'components/reusable/OMultiSelect';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import helpers from 'utils/helpers';
dayjs.extend(customParseFormat);

const MAX_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8];
const DEFAULT_TYPE_CLASSES = 'border rounded-full py-3 px-7';
const DEFAULT_TYPE_INACTIVE_CLASSES_SECOND = 'text-gray-700';
const DEFAULT_TYPE_ACTIVE_CLASSES = 'text-lime-500 bg-lime-100 border-lime-500';
const DEFAULT_NO_OF_CLASSES =
  'bg-[#F5F7FA] rounded-md p-2 w-[40px] h-[40px] xl:w-[54px] xl:h-[54px]';
const STUDIO_NO_OF_CLASSES =
  'bg-[#F5F7FA] rounded-md p-2 w-[70px] h-[40px] xl:w-[70px] xl:h-[54px]';
const NO_OF_ACTIVE_CLASSES = 'text-lime-500 bg-lime-100 border border-lime-500';
const NO_OF_IN_ACTIVE_CLASSES = 'text-gray-700';

const BasicInformation = ({ editProperty, setPropertyIdAndTabFn }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { config, setCountry } = useContext(AuthContext);
  const notification = useToastContext();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} });
  const [selected, setSelected] = useState('');
  const [isAmenities, setIsAmenities] = useState();
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [propertyCategoryTypes, setPropertyCategoryTypes] = useState([]);
  const [propertyType, setPropertyType] = useState('');
  const [propertyCategoryType, setPropertyCategoryType] = useState('');
  const [propertyAmenitiesList, setPropertyAmenitiesList] = useState([]);
  const [propertyAmenities, setPropertyAmenities] = useState([]);

  const [propertyBedrooms, setPropertyBedrooms] = useState('');
  const [propertyBathrooms, setPropertyBathrooms] = useState(0);
  const [propertyLivingRooms, setPropertyLivingRooms] = useState(0);
  const [propertyGuestRooms, setPropertyGuestRooms] = useState(0);
  const [agreementDate, setAgreementDate] = useState(new Date());
  const [type, setType] = useState('Buy');
  const [auctionStartDate, setAuctionStartDate] = useState(
    editProperty?.auctionStartDateTime
      ? new Date(editProperty?.auctionStartDateTime).toString()
      : ''
  );
  const [auctionEndDate, setAuctionEndDate] = useState(
    editProperty?.auctionStartDateTime
      ? new Date(editProperty?.auctionStartDateTime).toString()
      : ''
  );
  const [isAgentModalOpen, setIsAgentModalOpen] = useState(false);
  const [isAgentNameValid, setIsAgentNameValid] = useState('');
  const [isPropertyType, setIsPropertyType] = useState('');
  const [isAmenity, setIsAmenity] = useState('');
  const [description, setDescription] = useState('');
  const [descriptionAr, setDescriptionAr] = useState('');
  const [isPropertyCategory, setIsPropertyCategory] = useState('');
  const [isStartDateError, setIsStartDateError] = useState(false);
  const [isEndDateError, setIsEndDateError] = useState(false);
  const [isAuctionProperty, setIsAuctionProperty] = useState(false);
  const [isPropertyCategories, setIsPropertyCategories] = useState(false);
  const [availablPlans, setAvailablePlans] = useState([]);
  const [isMortgageAvailable, setIsMortgageAvailable] = useState(false);
  const [nearestFacilityApp, setNearestFacilityApp] = useState([]);
  const [nearestFacilityAppAr, setNearestFacilityAppAr] = useState([]);
  const [paymentOptions, setPaymentOption] = useState([
    {
      label: 'Full Payment',
      value: 'full_payment',
    },
  ]);
  const [channels, setChannels] = useState([]);
  const [propertyUtilities, setPropertyUtilities] = useState([]);
  const [propertyFaces, setPropertyFaces] = useState([]);
  const [propertyFacesAr, setPropertyFacesAr] = useState([]);
  const [propertyUsages, setPropertyUsages] = useState([]);
  const [propertyAge, setPropertyAge] = useState([]);
  const [titleDeedTypes, setTitleDeedTypes] = useState([]);
  const [adTypes, setAdTypes] = useState([]);
  const [creationDate, setCreationDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [selectedPropertyUsages, setSelectedPropertyUsages] = useState([]);
  const [selectedPropertyUtilities, setSelectedPropertyUtilities] = useState(
    []
  );
  const [mainLandUseTypeNames, setMainLandUseTypeNames] = useState([]);
  const [redZoneTypeNames, setRedZoneTypeNames] = useState([]);

  const [taxPrice, setTaxPrice] = useState({
    price: '',
    propertyTax: '',
    propertyTaxPercentage: '',
    commission: '',
    commissionPercentage: '',
    commissionTax: '',
    commissionTaxPercentage: '',
  });

  const paymentOptionsArray = [
    {
      label: 'Installment',
      value: 'installment',
    },
    {
      label: 'Full Payment',
      value: 'full_payment',
    },
    {
      label: 'Mortgage',
      value: 'mortgage',
    },
  ];

  const checkPath = () => {
    if (location.pathname.includes('auction')) {
      setIsAuctionProperty(true);
    } else {
      setIsAuctionProperty(false);
    }
  };
  const handleChangeCount = (newType, value, e) => {
    switch (newType) {
      case 'bedrooms':
        setPropertyBedrooms(value);

        break;
      case 'bathrooms':
        setPropertyBathrooms(value);

        break;
      case 'living_rooms':
        setPropertyLivingRooms(value);
        break;
      case 'guest_rooms':
        setPropertyGuestRooms(value);
        break;
      default:
        break;
    }
  };

  const handleChangeType = (value, e) => {
    setPropertyType(value?._id || null);
    setIsPropertyType('');
  };

  const checkRentedPrice = (data) => {
    data = {
      ...data,
      priceDaily: Number(data?.priceDaily),
      priceWeekly: Number(data?.priceWeekly),
      priceMonthly: Number(data?.priceMonthly),
      priceYearly: Number(data?.priceYearly),
    };
    if (isNumber(data?.priceDaily) && data?.priceDaily > 0) {
      return true;
    } else if (isNumber(data?.priceWeekly) && data?.priceWeekly > 0) {
      return true;
    } else if (isNumber(data?.priceMonthly) && data?.priceMonthly > 0) {
      return true;
    } else if (isNumber(data?.priceYearly) && data?.priceYearly > 0) {
      return true;
    } else {
      notification.error(t('PLEASE_ENTER_AT_LEAST_ONE_OF_THEM'));
      return false;
    }
  };

  const handleCategoryChangeType = (value, e) => {
    setPropertyCategoryType(value?._id || null);
    setIsPropertyCategory('');
  };

  const handleSubmitForm = async (data) => {
    try {
      let payload = {
        ...data,
        ...taxPrice,
        propertyTaxPercentage: taxPrice?.propertyTaxPercentage ?? 0,
        commissionPercentage: taxPrice?.commissionPercentage ?? 0,
        commissionTaxPercentage: taxPrice?.commissionTaxPercentage ?? 0,
        paymentOptions: paymentOptions.map((res) => res.value),
        propertyType,
        propertyCategory: propertyCategoryType,
        bedrooms: propertyBedrooms,
        bathrooms: propertyBathrooms,
        livingRooms: propertyLivingRooms,
        guestRooms: propertyGuestRooms,
        amenities: propertyAmenities,
        agentId: selected?._id || '',
        description,
        descriptionAr,
        agreementDate,
        isMortgageAvailable: isMortgageAvailable || false,
        nearestFacilityApp: nearestFacilityApp,
        nearestFacilityAppAr: nearestFacilityAppAr,
        propertyPlanId: !isEmpty(data?.propertyPlanId)
          ? data?.propertyPlanId
          : null,
      };
      if (!data?.priceDaily) {
        data.priceDaily = null;
      }
      if (!data?.priceMonthly) {
        data.priceMonthly = null;
      }
      if (!data?.priceWeekly) {
        data.priceWeekly = null;
      }
      if (!data?.priceYearly) {
        data.priceYearly = null;
      }
      if (isAuctionProperty) {
        let isValid = true;
        let isValidAuction = true;
        isValidAuction = checkAuctionDate();
        isValid = checkValidation();
        if (!isValid) return;
        if (!isValidAuction) return;
        payload.auctionStartDateTime = auctionStartDate;
        payload.auctionEndDateTime = auctionEndDate;
        payload.forAuction = true;
      } else {
        let isValid = true;
        isValid = checkValidation();
        if (!isValid) return;
      }
      const tempPropertyType = propertyTypes.find(
        ({ _id }) => _id === propertyType
      );
      const isRented = tempPropertyType?.name.includes('Rent');
      if (isRented) {
        const isValidPrice = checkRentedPrice(data);
        if (!isValidPrice) return;
      }

      if (config?.country === 'Saudi') {
        if (selectedChannel.length === 0) {
          notification.error(t('PLEASE_SELECT_CHANNELS'));
          setError('channels', {
            message: t('PLEASE_SELECT_CHANNELS'),
          });
          return;
        } else {
          clearErrors('channels');
        }

        if (selectedPropertyUtilities.length === 0) {
          notification.error(t('PLEASE_SELECT_PROPERTY_UTILITIES'));
          setError('propertyUtilities', {
            message: t('PLEASE_SELECT_PROPERTY_UTILITIES'),
          });
          return;
        } else {
          clearErrors('propertyUtilities');
        }

        if (dayjs(creationDate).isAfter(dayjs(endDate))) {
          notification.error(t('CREATION_DATE_SHOULD_BE_BEFORE_END_DATE'));
          return;
        }

        if (dayjs(endDate).isBefore(dayjs(creationDate))) {
          notification.error(t('END_DATE_SHOULD_BE_AFTER_CREATION_DATE'));
          return;
        }

        if (dayjs(endDate).isSame(dayjs(creationDate))) {
          notification.error(t('END_DATE_SHOULD_BE_AFTER_CREATION_DATE'));
          return;
        }
        payload = {
          ...payload,
          cityId: editProperty?.cityId || null,
          communityId: editProperty?.communityId || null,
          subCommunityId: editProperty?.subCommunityId || null,
          advertisementValidatorResponse:
            editProperty?.advertisementValidatorResponse || {},
          longitude: editProperty?.location
            ? editProperty?.location?.coordinates[0]
            : null,
          latitude: editProperty?.location
            ? editProperty?.location?.coordinates[1]
            : null,
          regaInfo: {
            ...editProperty?.regaInfo,
            operationReason: data.operationReason,
            adLinkInPlatform: data.adLinkInPlatform,
            adLicenseNumber: data.adLicenseNumber,
            brokerageAndMarketingLicenseNumber:
              data.brokerageAndMarketingLicenseNumber,
            titleDeedNumber: data.titleDeedNumber,
            creationDate: creationDate,
            endDate: endDate,
            advertiserId: data.advertiserId,
            advertiserName: data.advertiserName,
            advertiserNameAr: data.advertiserNameAr,
            advertiserMobile: data.advertiserMobile,
            channels: data.channels,
            propertyFace: data.layoutType,
            propertyType: data.propertyType,
            propertyArea: data.bua ? parseFloat(data.bua) : null,
            propertyUsage: data.propertyUsage,
            roomsNumber: data.roomsNumber,
            propertyAge: data.propertyAge,
            price: data.price ? parseFloat(data.price, 10) : null,
            propertyUtilities: data.propertyUtilities,
            adType: data.adType,
            isConstrained: data.isConstrained,
            obligationsOnTheProperty: data.obligationsOnTheProperty,
            guaranteesAndTheirDuration: data.guaranteesAndTheirDuration,
            planNumber: data.planNumber,
            landNumber: data.landNumber,
            complianceWithTheSaudiBuildingCode:
              data?.complianceWithTheSaudiBuildingCode
                ? data?.complianceWithTheSaudiBuildingCode
                : false,
            adLicenseUrl: data.adLicenseUrl,
            titleDeedType: data.titleDeedType,
            adSource: data.adSource,
            adSourceAr: data.adSourceAr,
            landTotalPrice: data.landTotalPrice
              ? parseFloat(data.landTotalPrice)
              : null,
            totalAnnualRentForTheLand: data.totalAnnualRentForTheLand
              ? parseFloat(data.totalAnnualRentForTheLand)
              : null,
            notes: data.notes,
            notesAr: data.notesAr,
            locationDescriptionAccordingToDeed:
              data.locationDescriptionAccordingToDeed,
            locationDescriptionAccordingToDeedAr:
              data.locationDescriptionAccordingToDeedAr,
            mainLandUseTypeName: data.mainLandUseTypeName,
            redZoneTypeName: data?.redZoneTypeName,
          },
        };

        if (isEmpty(editProperty?.regaInfo?.platformOwnerId)) {
          const validatorData =
            editProperty?.advertisementValidatorResponse?.advertisement;
          payload.regaInfo = {
            ...payload.regaInfo,
            borders: validatorData?.rerBorders,
            streetWidth: validatorData?.streetWidth
              ? parseFloat(validatorData?.streetWidth)
              : null,
            nationalAddress: {
              postalCode: validatorData?.location?.postalCode
                ? parseInt(validatorData?.location?.postalCode)
                : null,
              buildingNo: validatorData?.location?.buildingNumber
                ? parseInt(validatorData?.location?.buildingNumber)
                : null,
              additionalNo: validatorData?.location?.additionalNumber
                ? parseInt(validatorData?.location?.additionalNumber)
                : null,
              streetName: '',
              streetNameAr: validatorData?.location?.street,
            },
            northLimitName: '',
            northLimitNameAr: validatorData?.borders?.northLimitName,
            northLimitDescription: '',
            northLimitDescriptionAr:
              validatorData?.borders?.northLimitDescription,
            northLimitLengthChar: '',
            northLimitLengthCharAr:
              validatorData?.borders?.northLimitLengthChar,
            southLimitName: '',
            southLimitNameAr: validatorData?.borders?.southLimitName,
            southLimitDescription: '',
            southLimitDescriptionAr:
              validatorData?.borders?.southLimitDescription,
            southLimitLengthChar: '',
            southLimitLengthCharAr:
              validatorData?.borders?.southLimitLengthChar,
            eastLimitName: '',
            eastLimitNameAr: validatorData?.borders?.eastLimitName,
            eastLimitDescription: '',
            eastLimitDescriptionAr:
              validatorData?.borders?.eastLimitDescription,
            eastLimitLengthChar: '',
            eastLimitLengthCharAr: validatorData?.borders?.eastLimitLengthChar,
            westLimitName: '',
            westLimitNameAr: validatorData?.borders?.westLimitName,
            westLimitDescription: '',
            westLimitDescriptionAr:
              validatorData?.borders?.westLimitDescription,
            westLimitLengthChar: '',
            westLimitLengthCharAr: validatorData?.borders?.westLimitLengthChar,
          };
        }

        if (data?.propertyType === 'Land') {
          payload.regaInfo.propertyAge = null;
          payload.regaInfo.complianceWithTheSaudiBuildingCode = null;
        }
      }

      if (!isEmpty(editProperty?._id)) {
        const { data: response } = await apiPut(
          apiPath?.Properties + '/' + editProperty?._id,
          payload
        );

        if (response?.success) {
          notification.success(response?.message);
          if (!isEmpty(response.results._id)) {
            setPropertyIdAndTabFn(response.results._id, TAB_ADDRESS);
          } else {
            navigate('/properties');
          }
        } else {
          notification.error(response?.message);
        }
      } else {
        const { data: response } = await apiPost(apiPath.AddProperty, payload);
        if (response?.success) {
          notification.success(response?.message);
          if (!isEmpty(response.results._id)) {
            setPropertyIdAndTabFn(response.results._id, TAB_ADDRESS);
          } else {
            navigate('/properties');
          }
        } else {
          notification.error(response?.message);
        }
      }
    } catch (err) {
      console.error('err:', err);
      notification.error(err?.message);
    }
  };

  const fetchMasterRecords = async (data) => {
    try {
      const payload = {};
      const path = apiPath.PropertiesMasterData;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;

      if (location.pathname.includes('auction')) {
        const AuctionPropertyType = records.propertyTypes.filter(
          (element) =>
            element?.slug !== 'rent' && element?.slug !== 'commercial-rent'
        );
        setPropertyTypes(AuctionPropertyType);
      } else {
        setPropertyTypes(records?.propertyTypes || []);
      }
      setPropertyCategoryTypes(records?.propertyCategories || []);
      setPropertyAmenitiesList(records?.propertyAmenities || []);
      if (editProperty?.propertyType) {
        setPropertyType(editProperty?.propertyType?._id);
      }
      if (editProperty?.propertyCategoryType) {
        setPropertyCategoryType(editProperty?.propertyCategoryType?._id);
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };

  const statusOption = [
    { key: 'Off Plan Primary', value: 'offPlanPrimary' },
    { key: 'Secondary Ready', value: 'secondaryReady' },
    { key: 'Resale-plan Off', value: 'resalePlanOff' },
    { key: 'Resale-secondary', value: 'resaleSecondary' },
  ];

  const parkingTypeOption = [
    { key: 'Open', value: 'open' },
    { key: 'Covered', value: 'covered' },
    { key: 'Public', value: 'public' },
    { key: 'Closed', value: 'closed' },
  ];

  const furnishedOption = [
    { key: 'Unfurnished', value: 'unfurnished' },
    { key: 'Semi Furnished', value: 'semiFurnished' },
    { key: 'Furnished', value: 'furnished' },
  ];

  const financialStatusOption = [
    { key: 'Mortgaged', value: 'mortgaged' },
    { key: 'Cash', value: 'cash' },
  ];

  const agreementStatusOption = [
    { key: 'Diamond', value: 'diamond' },
    { key: 'Gold', value: 'gold' },
    { key: 'Silver', value: 'silver' },
    { key: 'Non Exclusive', value: 'non exclusive' },
  ];

  const stageOption = [
    { key: 'Vacant', value: 'vacant' },
    { key: 'Rented', value: 'rented' },
    { key: 'Vacant On Transfer', value: 'vacantOnTransfer' },
  ];

  const chequesOption = [
    { key: 1, value: 1 },
    { key: 2, value: 2 },
    { key: 3, value: 3 },
    { key: 4, value: 4 },
    { key: 5, value: 5 },
    { key: 6, value: 6 },
    { key: 7, value: 7 },
    { key: 8, value: 8 },
    { key: 9, value: 9 },
    { key: 10, value: 10 },
    { key: 11, value: 11 },
  ];

  const readyStageOption = [
    { key: 'Fitted', value: 'fitted' },
    { key: 'Semi Fitted', value: 'semiFitted' },
    { key: 'Shell', value: 'shell' },
    { key: 'Core', value: 'core' },
  ];

  const layoutOption = [
    { key: 'Facing North', value: 'Facing North' },
    { key: 'Facing West', value: 'Facing West' },
    { key: 'Facing East', value: 'Facing East' },
    { key: 'Facing South', value: 'Facing South' },
  ];

  const layoutOptionAr = [
    { key: 'مواجهة الشمال', value: 'مواجهة الشمال' },
    { key: 'مواجهة الغرب', value: 'مواجهة الغرب' },
    { key: 'مواجهة الشرق', value: 'مواجهة الشرق' },
    { key: 'التي تواجه الجنوب', value: 'التي تواجه الجنوب' },
  ];

  const isConstrainedOptions = [
    { key: 'True', value: 'True' },
    { key: 'False', value: 'False' },
  ];

  const complianceWithTheSaudiBuildingCodeOptions = [
    { key: 'True', value: true },
    { key: 'False', value: false },
  ];

  const addMoreNearestFacilityApp = (type) => {
    if (type === 'ar') {
      setNearestFacilityAppAr([
        ...nearestFacilityAppAr,
        { name: '', distance: '' },
      ]);
    } else {
      setNearestFacilityApp([
        ...nearestFacilityApp,
        { name: '', distance: '' },
      ]);
    }
  };

  const deleteMore = (type, index) => {
    switch (type) {
      case 'nearestFacilityAppAr':
        setNearestFacilityAppAr(
          nearestFacilityAppAr.filter(
            (percentage, tempIndex) => tempIndex !== index
          )
        );
        break;
      case 'nearestFacilityApp':
        setNearestFacilityApp(
          nearestFacilityApp.filter(
            (percentage, tempIndex) => tempIndex !== index
          )
        );
        break;
      default:
        break;
    }
  };

  const handleAuctionStartDate = (date) => {
    setAuctionStartDate(date);
    setIsStartDateError(false);
  };

  const handleAuctionEndDate = (date) => {
    setAuctionEndDate(date);
    setIsEndDateError(false);
  };

  const preventDecimalAfterTwoDigit = (e) => {
    if (e.target.value.includes('.')) {
      const tempSplit = e.target.value.split('.');
      e.target.value = tempSplit[0] + '.' + tempSplit[1].slice(0, 2);
    }
  };

  const checkValidation = () => {
    let isValid = true;
    if (!isAuctionProperty) {
      if (!selected) {
        isValid = false;
        setIsAgentNameValid('Please select agent name.');
      } else {
        // isValid = true
        setIsAgentNameValid('');
      }
    }
    if (!propertyType) {
      isValid = false;
      setIsPropertyType('Please select property type.');
    } else {
      setIsPropertyType('');
    }

    if (!propertyCategoryType) {
      isValid = false;
      setIsPropertyCategory('Please select property category.');
    } else {
      // isValid = true
      setIsPropertyCategory('');
    }
    if (propertyAmenities?.length === 0) {
      isValid = false;
      setIsAmenity('Please select amenities.');
    } else {
      // isValid = true
      setIsAmenity('');
    }
    return isValid;
  };
  const checkAuctionDate = () => {
    let isValid = true;
    if (auctionStartDate === 'Invalid Date' || auctionStartDate === '') {
      setIsStartDateError(true);
      isValid = false;
    } else {
      setIsStartDateError(false);
    }

    if (auctionEndDate === 'Invalid Date' || auctionEndDate === '') {
      setIsEndDateError(true);
      isValid = false;
    } else {
      setIsEndDateError(false);
    }

    return isValid;
  };

  useEffect(() => {
    fetchMasterRecords();
    checkPath();
    setCountry(localStorage.getItem('country'));
    getPropertyPlans();
    // eslint-disable-next-line
  }, []);

  const getPropertyPlans = async () => {
    try {
      const path = apiPath.getPropertyPlans;
      const result = await apiGet(path);
      const { status, data } = result;
      if (status === 200) {
        setAvailablePlans(
          data?.results?.map((res) => {
            return { key: res.lable, value: res._id };
          })
        );
      }
    } catch (error) {
      console.log('error==>>>>', error.message);
    }
  };

  // useEffect(() => {
  //   if (propertyType && propertyCategoryTypes.length > 0) {
  //     const temp = propertyCategoryTypes.filter(
  //       (pt) => pt.propertyTypeId.toString() === propertyType
  //     );
  //     const isIncludeCategory = temp.filter(
  //       (item) => item?._id.toString() === propertyCategoryType.toString()
  //     );
  //     if (isIncludeCategory.length === 0) {
  //       // setPropertyCategoryType('');
  //     }
  //   }
  // }, [propertyCategoryType, propertyCategoryTypes, propertyType]);

  const timeoutRef = useRef(false);
  useEffect(() => {

    if (timeoutRef.current)  return;
    timeoutRef.current = true;
    const timeout = setTimeout(() => {

      const {
        price,
        propertyTaxPercentage,
        commissionPercentage,
        commissionTaxPercentage,
      } = taxPrice;

      const propertyTax = getPercentage(price, propertyTaxPercentage);
      const commission = getPercentage(price, commissionPercentage);
      const commissionTax = getPercentage(commission, commissionTaxPercentage);

      setTaxPrice((prev) => ({
        ...prev,
        propertyTax,
        commission,
        commissionTax,
      }));
      timeoutRef.current = false;
    }, 500);

    return () => {
      clearTimeout(timeout);
      timeoutRef.current = false;
    };
  }, []);
  
  const getPercentage = (price, value) => {
    return (price * (parseFloat(value) || 0)) / 100;
  };

  const handleInputChange = (field, value) => {
    const numberValue = parseFloat(value);
    if (!isNaN(numberValue)) {
      setTaxPrice((prev) => ({
        ...prev,
        [field]: Math.min(Math.max(numberValue, 0), 100), // Clamp value between 0 and 100
      }));
    } else {
      setTaxPrice((prev) => ({
        ...prev,
        [field]: null, // Set to 0 if input is invalid
      }));
    }
  };

  useEffect(() => {
    if (!isEmpty(editProperty)) {
      setPropertyType(editProperty?.propertyType?._id);
      setPropertyCategoryType(editProperty?.propertyCategory?._id);
      setPropertyBedrooms(editProperty?.bedrooms);
      setPropertyBathrooms(editProperty?.bathrooms);
      setPropertyLivingRooms(editProperty?.livingRooms);
      setPropertyGuestRooms(editProperty?.guestRooms);
      setValue('title', editProperty?.title);
      setValue('slug', editProperty?.slug);
      setValue('slugAr', editProperty?.slugAr);
      setValue('titleAr', editProperty?.titleAr);
      setValue('sub_title', editProperty?.sub_title);
      setValue('sub_titleAr', editProperty?.sub_titleAr);
      setValue('parking', editProperty?.parking);
      setValue('parkingAr', editProperty?.parkingAr || '');
      setValue('propertySize', editProperty?.propertySize);
      setValue('layoutType', editProperty?.layoutType);
      setValue('layoutTypeAr', editProperty?.layoutTypeAr);
      setValue('serviceCharge', editProperty?.serviceCharge);
      setValue('pricePerUnit', editProperty?.pricePerUnit);
      setValue('biddingFees', editProperty?.biddingFees);
      setValue('bua', editProperty?.bua);
      setValue('price', editProperty?.price);
      setValue('priceDaily', editProperty?.priceDaily);
      setValue('priceWeekly', editProperty?.priceWeekly);
      setValue('priceMonthly', editProperty?.priceMonthly);
      setValue('priceYearly', editProperty?.priceYearly);
      setValue('parkingType', editProperty?.parkingType);
      setValue('readyStage', editProperty?.readyStage);
      setValue('stage', editProperty?.stage);
      setValue('financialStatus', editProperty?.financialStatus);
      setValue('projectStatus', editProperty?.projectStatus);
      setValue('furnished', editProperty?.furnished);
      setValue('permitNumber', editProperty?.permitNumber);
      setPropertyAmenities(
        editProperty?.amenities?.length > 0
          ? editProperty?.amenities?.map((obj) => obj._id)
          : []
      );
      setValue('securityDeposit', editProperty?.securityDeposit);
      setValue('cheques', editProperty?.cheques);
      setValue('advertType', editProperty?.advertType);
      setValue('advertTypeAr', editProperty?.advertTypeAr);
      setValue('totalFloors', editProperty?.totalFloors);
      setValue('floorNumber', editProperty?.floorNumber);
      setValue('agreementDate', editProperty?.agreementDate);
      editProperty?.agreementDate &&
        setAgreementDate(editProperty?.agreementDate);
      setValue('paymentOptions', editProperty?.paymentOptions);

      const selectedPaymentOptions = paymentOptionsArray.filter((option) =>
        editProperty?.paymentOptions?.includes(option.value)
      );
      setPaymentOption(selectedPaymentOptions);

      if (editProperty?.description) setDescription(editProperty?.description);
      if (editProperty?.descriptionAr)
        setDescriptionAr(editProperty?.descriptionAr);

      setValue('metaTitle', editProperty?.metaTitle);
      setValue('metaTitleAr', editProperty?.metaTitleAr);
      setValue('metaDescription', editProperty?.metaDescription);
      setValue('metaDescriptionAr', editProperty?.metaDescriptionAr);
      setValue('keyword', editProperty?.keyword);
      setValue('keywordAr', editProperty?.keywordAr);
      setValue('owner_name', editProperty?.owner_name);
      setValue('owner_email', editProperty?.owner_email);
      setValue('owner_phone', editProperty?.owner_phone);
      setValue('licenseNumber', editProperty?.licenseNumber);
      setValue('appBrochure', editProperty?.appBrochure);
      setValue('url360', editProperty?.url360);
      setValue('totalArea', editProperty?.totalArea);
      setValue('agreementStatus', editProperty?.agreementStatus);
      setValue('propertyPlanId ', editProperty?.propertyPlanId);

      setValue('maidsRoom', editProperty?.maidsRoom || '');
      setValue('driverRoom', editProperty?.driverRoom || '');
      setType(editProperty?.propertyType?.name);
      editProperty?.auctionStartDateTime &&
        setValue(
          'startDate',
          new Date(editProperty?.auctionStartDateTime).toString()
        );

      setSelected(editProperty?.agent);
      editProperty?.auctionStartDateTime &&
        setAuctionStartDate(
          new Date(editProperty?.auctionStartDateTime).toString()
        );
      editProperty?.auctionEndDateTime &&
        setAuctionEndDate(
          new Date(editProperty?.auctionEndDateTime).toString()
        );

      setIsMortgageAvailable(editProperty?.isMortgageAvailable || false);
      setNearestFacilityApp(editProperty?.nearestFacilityApp || []);
      setNearestFacilityAppAr(editProperty?.nearestFacilityAppAr || []);
      setTaxPrice({
        price: editProperty?.price,
        propertyTax: editProperty?.propertyTax,
        propertyTaxPercentage: editProperty?.propertyTaxPercentage,
        commission: editProperty?.commission,
        commissionPercentage: editProperty?.commissionPercentage,
        commissionTax: editProperty?.commissionTax,
        commissionTaxPercentage: editProperty?.commissionTaxPercentage,
      });
      setValue('accountName', editProperty?.accountName || '');
      setValue('accountNameAr', editProperty?.accountNameAr || '');
      setValue('bankName', editProperty?.bankName || '');
      setValue('bankNameAr', editProperty?.bankNameAr || '');
      setValue(
        'downPaymentPercentage',
        editProperty?.downPaymentPercentage || 0
      );
      setValue('iban', editProperty?.iban || '');
    }
  }, [editProperty]);

  function normalizeArabic(text) {
    return text
      .replace(/[\u0625\u0623\u0622]/g, 'ا') // Replace إ, أ, آ with ا
      .replace(/[^\u0600-\u06FF\s]/g, '') // Remove non-Arabic characters
      .replace(/[\u064B-\u065F]/g, '') // Remove tashkeel (diacritics)
      .trim();
  }

  useEffect(() => {
    if (propertyTypes?.length > 0 && !isEmpty(editProperty)) {
      if (
        config?.country === 'Saudi' &&
        isEmpty(editProperty?.propertyType?._id) &&
        !isEmpty(
          editProperty?.advertisementValidatorResponse?.advertisement
            ?.advertisementType
        )
      ) {
        const adType = normalizeArabic(
          editProperty?.advertisementValidatorResponse?.advertisement
            ?.advertisementType
        );

        const propertyUsages =
          editProperty?.advertisementValidatorResponse?.advertisement
            ?.propertyUsages;

        if (propertyUsages.includes('تجاري') && adType === 'بيع') {
          const propertyType = propertyTypes.find(
            (i) => i?.slug === 'commercial-buy'
          );
          setPropertyType(propertyType?._id);
          setType('Commercial Buy');
        } else if (
          propertyUsages.includes('تجاري') &&
          ['ايجار', 'إيجار'].includes(adType)
        ) {
          const propertyType = propertyTypes.find(
            (i) => i?.slug === 'commercial-rent'
          );
          setPropertyType(propertyType?._id);
          setType('Commercial Rent');
        } else if (adType === 'بيع') {
          const propertyType = propertyTypes.find((i) => i?.slug === 'buy');
          setPropertyType(propertyType?._id);
          setType('Buy');
        } else if (adType === 'ايجار') {
          const propertyType = propertyTypes.find((i) => i?.slug === 'rent');
          setPropertyType(propertyType?._id);
          setType('Rent');
        }
      } else {
        setPropertyType(editProperty?.propertyType?._id);
      }
    }
  }, [propertyTypes, propertyCategoryTypes, editProperty, config?.country]);

  useEffect(() => {
    if (propertyCategoryTypes?.length > 0 && !isEmpty(editProperty)) {
      if (
        config?.country === 'Saudi' &&
        isEmpty(editProperty?.propertyCategory?._id) &&
        !isEmpty(
          editProperty?.advertisementValidatorResponse?.advertisement
            ?.propertyType
        )
      ) {
        const categoryFound = propertyCategoryTypes.find(
          (catType) =>
            catType?.nameAr ===
              editProperty?.advertisementValidatorResponse?.advertisement
                ?.propertyType && catType?.propertyTypeId == propertyType
        );

        setPropertyCategoryType(categoryFound?._id);
      } else {
        setPropertyCategoryType(editProperty?.propertyCategory?._id);
      }
    }
  }, [config?.country, editProperty, propertyCategoryTypes, propertyType]);

  useEffect(() => {
    if (!isEmpty(editProperty) && config?.country === 'Saudi') {
      const validatorData =
        editProperty?.advertisementValidatorResponse?.advertisement;
      const regaData = editProperty?.regaInfo;

      const isPlatformOwnerEmpty = isEmpty(regaData?.platformOwnerId);

      const data = isPlatformOwnerEmpty ? validatorData : regaData;

      setValue('adLinkInPlatform', data?.adLinkInPlatform);
      setValue('adLicenseNumber', data?.adLicenseNumber);
      setValue(
        'brokerageAndMarketingLicenseNumber',
        data?.brokerageAndMarketingLicenseNumber
      );
      setValue(
        'titleDeedNumber',
        isPlatformOwnerEmpty ? data?.deedNumber : data?.titleDeedNumber
      );

      const formattedCreationDate = isPlatformOwnerEmpty
        ? helpers.parseAndFormatDate(data?.creationDate, 'DD/MM/YYYY')
        : helpers.parseAndFormatDate(data?.creationDate, undefined);

      setValue('creationDate', formattedCreationDate);
      setCreationDate(formattedCreationDate);

      const formattedEndDate = isPlatformOwnerEmpty
        ? helpers.parseAndFormatDate(data?.endDate, 'DD/MM/YYYY')
        : helpers.parseAndFormatDate(data?.endDate, undefined);

      setValue('endDate', formattedEndDate);
      setEndDate(formattedEndDate);

      setValue('advertiserId', data?.advertiserId);
      setValue(
        'advertiserName',
        isPlatformOwnerEmpty ? '' : data?.advertiserName
      );
      setValue(
        'advertiserNameAr',
        isPlatformOwnerEmpty ? data?.advertiserName : data?.advertiserNameAr
      );
      setValue('advertiserMobile', data?.advertiserMobile);
      setValue(
        'channels',
        isPlatformOwnerEmpty
          ? channels
              .filter((ch) => data?.channels?.includes(ch?.labelAr))
              .map((i) => i.value)
          : data?.channels
      );
      setSelectedChannel(
        isPlatformOwnerEmpty
          ? channels.filter((ch) => data?.channels?.includes(ch?.labelAr))
          : channels.filter((item) => data?.channels?.includes(item?.value))
      );
      setValue(
        'layoutType',
        isPlatformOwnerEmpty
          ? propertyFaces?.find((pf) => pf?.keyAr === data?.propertyFace)?.value
          : editProperty?.layoutType
      );
      setValue(
        'layoutTypeAr',
        isPlatformOwnerEmpty
          ? propertyFacesAr?.find((pf) => pf?.key === data?.propertyFace)?.value
          : editProperty?.layoutTypeAr
      );
      setValue('propertyFace', editProperty?.layoutType);
      setValue('propertyType', data?.propertyType);

      setValue(
        'propertyUsage',
        isPlatformOwnerEmpty
          ? propertyUsages
              ?.filter((p) => data?.propertyUsages?.includes(p?.labelAr))
              ?.map((i) => i.value)
          : data?.propertyUsage
      );
      setSelectedPropertyUsages(
        isPlatformOwnerEmpty
          ? propertyUsages?.filter((p) =>
              data?.propertyUsages?.includes(p?.labelAr)
            )
          : propertyUsages.filter((item) =>
              data?.propertyUsage?.includes(item?.value)
            )
      );
      setValue('roomsNumber', data?.roomsNumber);
      setValue(
        'propertyAge',
        isPlatformOwnerEmpty
          ? propertyAge.find((p) => p?.keyAr === data?.propertyAge)?.value
          : editProperty?.propertyAge
      );
      setValue(
        'price',
        isPlatformOwnerEmpty ? data?.propertyPrice : data?.price
      );
      setValue(
        'propertyUtilities',
        isPlatformOwnerEmpty
          ? propertyUtilities
              .filter((p) => data?.propertyUtilities?.includes(p?.labelAr))
              .map((i) => i?.value)
          : data?.propertyUtilities
      );
      setSelectedPropertyUtilities(
        isPlatformOwnerEmpty
          ? propertyUtilities?.filter((p) =>
              data?.propertyUtilities?.includes(p?.labelAr)
            )
          : propertyUtilities.filter((item) =>
              data?.propertyUtilities?.includes(item?.value)
            )
      );
      setValue('adType', data?.adType);
      setValue(
        'isConstrained',
        isPlatformOwnerEmpty
          ? data?.isConstrained
            ? 'True'
            : 'False'
          : data?.isConstrained
      );
      setValue('obligationsOnTheProperty', data?.obligationsOnTheProperty);
      setValue('guaranteesAndTheirDuration', data?.guaranteesAndTheirDuration);
      setValue('planNumber', data?.planNumber);
      setValue('landNumber', data?.landNumber);
      setValue(
        'complianceWithTheSaudiBuildingCode',
        data?.complianceWithTheSaudiBuildingCode
          ? data?.complianceWithTheSaudiBuildingCode
          : false
      );
      setValue(
        'adLicenseUrl',
        isPlatformOwnerEmpty ? data?.adLicenseUrl : data?.adLicenseUrl
      );
      setValue(
        'titleDeedType',
        isPlatformOwnerEmpty
          ? titleDeedTypes.find((p) => p?.keyAr === data?.titleDeedTypeName)
              ?.value
          : data?.titleDeedType
      );
      setValue('adSource', isPlatformOwnerEmpty ? '' : data?.adSource);
      setValue(
        'adSourceAr',
        isPlatformOwnerEmpty ? data?.adSource : data?.adSourceAr
      );
      setValue('landTotalPrice', data?.landTotalPrice);
      setValue(
        'totalAnnualRentForTheLand',
        isPlatformOwnerEmpty
          ? data?.landTotalAnnualRent
          : data?.totalAnnualRentForTheLand
      );
      setValue('notes', data?.notes);
      setValue('notesAr', data?.notesAr);
      setValue(
        'locationDescriptionAccordingToDeed',
        isPlatformOwnerEmpty
          ? data?.locationDescriptionOnMOJDeed
          : data?.locationDescriptionAccordingToDeed
      );
      setValue(
        'locationDescriptionAccordingToDeedAr',
        isPlatformOwnerEmpty
          ? data?.locationDescriptionOnMOJDeed
          : data?.locationDescriptionAccordingToDeedAr
      );

      setValue(
        'mainLandUseTypeName',
        isPlatformOwnerEmpty
          ? mainLandUseTypeNames.find(
              (i) => i.key === data?.mainLandUseTypeName
            )?.value
          : data?.mainLandUseTypeName
      );
      setValue(
        'redZoneTypeName',
        isPlatformOwnerEmpty
          ? redZoneTypeNames.find((i) => i.key === data?.redZoneTypeName)?.value
          : data?.redZoneTypeName
      );
    }
  }, [
    editProperty,
    config,
    channels,
    propertyUsages,
    propertyUtilities,
    mainLandUseTypeNames,
    redZoneTypeNames,
  ]);

  const fetchRegaInfo = async () => {
    try {
      const { data, status } = await apiGet(apiPath.getRegaInfo);
      if (status === 200) {
        const {
          CHANNELS,
          PROPERTY_UTILITIES,
          PROPERTY_FACES,
          PROPERTY_USAGES,
          PROPERTY_AGE,
          TITLE_DEED_TYPES,
          AD_TYPES,
          MAIN_LAND_USE_TYPE_NAMES,
          RED_ZONE_TYPE_NAMES,
        } = data.results;

        setChannels(() =>
          CHANNELS.map((item) => {
            return {
              labelAr: item.labelAr,
              label: item.label,
              value: item.id,
            };
          })
        );
        setPropertyUtilities(() =>
          PROPERTY_UTILITIES.map((item) => {
            return {
              labelAr: item.labelAr,
              label: item.label,
              value: item.id,
            };
          })
        );
        setPropertyUsages(() =>
          PROPERTY_USAGES.map((item) => {
            return {
              labelAr: item.labelAr,
              label: item.label,
              value: item.id,
            };
          })
        );
        setPropertyFaces(
          PROPERTY_FACES.map((item) => {
            return {
              keyAr: item.labelAr,
              key: item.label,
              value: item.label,
            };
          })
        );
        setPropertyFacesAr(
          PROPERTY_FACES.map((item) => {
            return {
              key: item.labelAr,
              value: item.labelAr,
            };
          })
        );
        setPropertyAge(
          PROPERTY_AGE.map((item) => {
            return {
              keyAr: item.labelAr,
              key: item.label,
              value: item.id,
            };
          })
        );
        setTitleDeedTypes(
          TITLE_DEED_TYPES.map((item) => {
            return {
              keyAr: item.labelAr,
              key: item.label,
              value: item.id,
            };
          })
        );
        setAdTypes(
          AD_TYPES.map((item) => {
            return {
              keyAr: item.labelAr,
              key: item.label,
              value: item.id,
            };
          })
        );
        setMainLandUseTypeNames(
          MAIN_LAND_USE_TYPE_NAMES.map((item) => {
            return {
              keyAr: item.labelAr,
              key: item.label,
              value: item.id,
            };
          })
        );
        setRedZoneTypeNames(
          RED_ZONE_TYPE_NAMES.map((item) => ({
            keyAr: item.labelAr,
            key: item.label,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.log('rega info error', error);
    }
  };

  useEffect(() => {
    if (config?.country === 'Saudi') {
      fetchRegaInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config?.country]);

  const handleChannelChange = (selectedOption) => {
    setSelectedChannel(selectedOption);
    setValue(
      'channels',
      selectedOption?.length > 0 ? selectedOption.map((item) => item.value) : []
    );
    clearErrors('channels');
  };

  const handlePropertyUtilitiesChange = (selectedOption) => {
    setSelectedPropertyUtilities(selectedOption);
    setValue(
      'propertyUtilities',
      selectedOption?.length > 0 ? selectedOption.map((item) => item.value) : []
    );
    clearErrors('propertyUtilities');
  };

  const handlePropertyUsageChange = (selectedOption) => {
    setSelectedPropertyUsages(selectedOption);
    setValue(
      'propertyUsage',
      selectedOption?.length > 0 ? selectedOption.map((item) => item.value) : []
    );
  };

  return (
    <>
      <div className="basic_info">
        <form
          className="py-4"
          onSubmit={handleSubmit(handleSubmitForm, () => {
            checkAuctionDate();
            checkValidation();
          })}
        >
          <div className="py-3 mb-1">
            <h4 className="text-lg">{t('O_TYPE')}</h4>
            <ul className="flex py-2">
              {propertyTypes.map((pt, index) => (
                <li
                  onClick={() => {
                    handleChangeType(pt);
                    setType(pt?.name);
                  }}
                  key={pt.id}
                  className="mr-2 text-md"
                >
                  <button
                    type="button"
                    className={classNames({
                      [DEFAULT_TYPE_CLASSES]: true,
                      [DEFAULT_TYPE_ACTIVE_CLASSES]: pt._id === propertyType,
                      [DEFAULT_TYPE_INACTIVE_CLASSES_SECOND]:
                        pt._id !== propertyType,
                    })}
                  >
                    {pt.name}
                  </button>
                </li>
              ))}
            </ul>
            {isPropertyType && <ErrorMessage message={isPropertyType} />}
          </div>

          <div className="py-3 mb-1">
            <div className="my-2 flex">
              <div className="mr-4">
                {/* <h4 className='text-lg'>{t('PROPERTY_CATEGORY')}</h4> */}
                <span
                  className="cursor-pointer bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  onClick={() => setIsPropertyCategories(true)}
                >
                  {t('PROPERTY_CATEGORIES_SELECTED')}
                </span>
                {propertyCategoryType?.length > 0 && (
                  <>
                    (<span className="pr-1">1</span>{' '}
                    <span className="">{t('SELECTED')}</span>)
                  </>
                )}
                {isPropertyCategory && (
                  <span className="block mt-3">
                    <ErrorMessage message={isPropertyCategory} />
                  </span>
                )}
              </div>

              <div className="mr-4">
                {/* <h4 className='text-lg'>{t('AMENITIES')}</h4> */}
                <span
                  className="cursor-pointer bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  onClick={() => setIsAmenities(true)}
                >
                  {t('SELECT_AMENITIES')}
                </span>
                {propertyAmenities?.length !== 0 && (
                  <>
                    (<span className="pr-1">{propertyAmenities?.length}</span>{' '}
                    <span className="">{t('SELECTED')}</span>)
                  </>
                )}
                {isAmenity && (
                  <span className="block mt-3">
                    <ErrorMessage message={isAmenity} />
                  </span>
                )}
              </div>
              {!isAuctionProperty && (
                <div>
                  {/* <h4 className='text-lg'>{t('AGENT')}</h4> */}
                  <span
                    className="cursor-pointer bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    onClick={setIsAgentModalOpen}
                  >
                    {t('SELECT_AGENT')}
                  </span>
                  {selected && (
                    <span className="pr-1">
                      {`${selected?.firstName} ${selected?.lastName} `}{' '}
                      {selected?.brn && `(${selected?.brn})`}
                    </span>
                  )}
                  {isAgentNameValid && (
                    <span className="block mt-3">
                      <ErrorMessage message={isAgentNameValid} />
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="flex  gap-12">
            {type !== 'Commercial Buy' && type !== 'Commercial Rent' && (
              <>
                <div className="py-3 mb-1 flex-0">
                  <h4 className="text-lg">
                    {t('NUMBER_OF_BEDROOMS')}{' '}
                    {/* <span className='text-red-500'>*</span> */}
                  </h4>

                  <ul className="flex flex-wrap py-2">
                    <li
                      className="mr-2 mb-2 text-md"
                      onClick={handleChangeCount.bind(this, 'bedrooms', 0)}
                    >
                      <button
                        type="button"
                        className={classNames({
                          [STUDIO_NO_OF_CLASSES]: true,
                          [NO_OF_ACTIVE_CLASSES]: propertyBedrooms === 0,
                          [NO_OF_IN_ACTIVE_CLASSES]: propertyBedrooms !== 0,
                        })}
                      >
                        Studio
                      </button>
                    </li>
                    {MAX_NUMBERS.map((value, index) => {
                      return (
                        <li
                          className="mr-2 mb-2 text-md"
                          onClick={handleChangeCount.bind(
                            this,
                            'bedrooms',
                            value
                          )}
                          key={value.id}
                        >
                          <button
                            type="button"
                            className={classNames({
                              [DEFAULT_NO_OF_CLASSES]: true,
                              [NO_OF_ACTIVE_CLASSES]:
                                value === propertyBedrooms,
                              [NO_OF_IN_ACTIVE_CLASSES]:
                                value !== propertyBedrooms,
                            })}
                          >
                            {value > 7 ? `${value - 1}+` : value}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <div className="py-3 mb-1 flex-0">
                  <h4 className="text-lg">
                    {t('NUMBER_OF_BATHROOMS')}
                    {/* <span className='text-red-500'>*</span> */}
                  </h4>
                  <ul className="flex flex-wrap py-2">
                    {MAX_NUMBERS.map((value, index) => {
                      return (
                        <li
                          className="mr-2 mb-2 text-md"
                          onClick={handleChangeCount.bind(
                            this,
                            'bathrooms',
                            value
                          )}
                          key={value.id}
                        >
                          <button
                            type="button"
                            className={classNames({
                              [DEFAULT_NO_OF_CLASSES]: true,
                              [NO_OF_ACTIVE_CLASSES]:
                                value === propertyBathrooms,
                              [NO_OF_IN_ACTIVE_CLASSES]:
                                value !== propertyBathrooms,
                            })}
                          >
                            {value > 7 ? `${value - 1}+` : value}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </>
            )}
          </div>
          {config?.country === 'Saudi' && (
            <div className="flex  gap-12">
              <div className="py-3 mb-1 flex-0">
                <h4 className="text-lg">{t('NUMBER_OF_LIVING_ROOMS')}</h4>
                <ul className="flex flex-wrap py-2">
                  {MAX_NUMBERS.map((value, index) => {
                    return (
                      <li
                        className="mr-2 mb-2 text-md"
                        onClick={handleChangeCount.bind(
                          this,
                          'living_rooms',
                          value
                        )}
                        key={value.id}
                      >
                        <button
                          type="button"
                          className={classNames({
                            [DEFAULT_NO_OF_CLASSES]: true,
                            [NO_OF_ACTIVE_CLASSES]:
                              value === propertyLivingRooms,
                            [NO_OF_IN_ACTIVE_CLASSES]:
                              value !== propertyLivingRooms,
                          })}
                        >
                          {value > 7 ? `${value - 1}+` : value}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className="py-3 mb-1 flex-0">
                <h4 className="text-lg">{t('NUMBER_OF_GUEST_ROOMS')}</h4>
                <ul className="flex flex-wrap py-2">
                  {MAX_NUMBERS.map((value, index) => {
                    return (
                      <li
                        className="mr-2 mb-2 text-md"
                        onClick={handleChangeCount.bind(
                          this,
                          'guest_rooms',
                          value
                        )}
                        key={value.id}
                      >
                        <button
                          type="button"
                          className={classNames({
                            [DEFAULT_NO_OF_CLASSES]: true,
                            [NO_OF_ACTIVE_CLASSES]:
                              value === propertyGuestRooms,
                            [NO_OF_IN_ACTIVE_CLASSES]:
                              value !== propertyGuestRooms,
                          })}
                        >
                          {value > 7 ? `${value - 1}+` : value}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}

          {/* <div className='pt-3 mb-1'>
            <h4 className='text-lg'>{t('AMENITIES')}</h4>
            <div className='my-2'>
              <span
                className='bg-[#8FC150] cursor-pointer text-sm px-4 mr-2  my-4 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                onClick={() => setIsAmenities(true)}
              >
                {t('SELECT_AMENITIES')}
              </span>
              {propertyAmenities.length !== 0 && (
                <>
                  (<span className='pr-1'>{propertyAmenities.length}</span>{' '}
                  <span className=''>{t('SELECTED')}</span>)
                </>
              )}
              {isAmenity && (
                <span className='block mt-3'>
                  <ErrorMessage message={isAmenity} />
                </span>
              )}
            </div>
          </div> */}
          {/* <div className=''> */}
          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="title"
                  inputLabel={
                    <>
                      {t('PROPERTY_TITLE')}
                      <span className="text-red-500">*</span>
                    </>
                  }
                  type="text"
                  register={register('title', {
                    required: 'Please enter title.',
                    minLength: {
                      value: 2,
                      message: 'Minimum length must be 2.',
                    },
                    validate: (value) =>
                      value.trim() ? true : 'White spaces not allowed.',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="titleAr"
                  inputLabel={
                    <>
                      {t('PROPERTY_TITLE') + t('O_ARABIC')}
                      <span className="text-red-500">*</span>
                    </>
                  }
                  type="text"
                  register={register('titleAr', {
                    required: 'Please enter title in arabic.',
                    minLength: {
                      value: 2,
                      message: 'Minimum length must be 2.',
                    },
                    validate: (value) =>
                      value.trim() ? true : 'White spaces not allowed.',
                  })}
                  errors={errors}
                />
              </label>
            </div>
          </div>
          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="sub_title"
                  inputLabel={<>{t('PROPERTY_SUBTITLE')}</>}
                  type="text"
                  register={register('sub_title')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="sub_titleAr"
                  inputLabel={<>{t('PROPERTY_SUBTITLE') + t('O_ARABIC')}</>}
                  type="text"
                  register={register('sub_titleAr')}
                  errors={errors}
                />
              </label>
            </div>
          </div>
          {editProperty?.slug && (
            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="slug"
                    inputLabel={
                      <>
                        {t('O_SLUG')}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="text"
                    register={register('slug', formValidation.slug)}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="slugAr"
                    inputLabel={
                      <>
                        {t('O_SLUG') + t('O_ARABIC')}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="text"
                    register={register('slugAr', formValidation.slugAr)}
                    errors={errors}
                  />
                </label>
              </div>
            </div>
          )}

          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="maidsRoom"
                  preventDecimal
                  inputLabel={<>{t('MAIDS_ROOM')}</>}
                  type="number"
                  register={register('maidsRoom', {
                    onChange: (event) => {
                      const tempPricePerUnit = Number.parseInt(
                        (
                          Number.parseInt(event.target.value) / getValues('bua')
                        ).toFixed(2)
                      );
                      if (
                        tempPricePerUnit > 0 &&
                        tempPricePerUnit !== 'Infinity'
                      ) {
                        setValue('maidsRoom', tempPricePerUnit);
                      }
                    },
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="driverRoom"
                  preventDecimal
                  inputLabel={<>{t('DRIVER_ROOM')}</>}
                  type="number"
                  register={register('driverRoom', {
                    onChange: (event) => {
                      const tempPricePerUnit = Number.parseInt(
                        (
                          Number.parseInt(event.target.value) / getValues('bua')
                        ).toFixed(2)
                      );
                      if (
                        tempPricePerUnit > 0 &&
                        tempPricePerUnit !== 'Infinity'
                      ) {
                        setValue('driverRoom', tempPricePerUnit);
                      }
                    },
                  })}
                  errors={errors}
                />
              </label>
            </div>
          </div>
          <div className="grid grid-rows-1 grid-cols-4 gap-4">
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="propertySize"
                  inputLabel={
                    <>
                      {t('PLOT_SIZE')} ({config?.areaUnit})
                      {/* <span className='text-red-500'>*</span> */}
                    </>
                  }
                  type="number"
                  step="any"
                  preventDecimal
                  register={register('propertySize', {
                    // required: 'Please enter property size.',
                    // minLength: {
                    //   value: 2,
                    //   message: 'Minimum length must be 2.'
                    // },
                    onChange: (e) => helper.preventDecimal(e),
                  })}
                  errors={errors}
                />
              </label>

              {/* </div> */}
              {/* <ErrorMessage message={errors?.propertySize?.message} /> */}
            </div>
            {(type === 'Buy' || type === 'Commercial Buy') && (
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="price"
                    preventDecimal
                    inputLabel={
                      <>
                        {t('EXPECTED_PRICE')} ({config?.currency})
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="number"
                    errors={errors}
                    step="any"
                    value={taxPrice.price}
                    onChange={(e) =>
                      setTaxPrice({
                        ...taxPrice,
                        price: e.target.value,
                      })
                    }
                    register={register('price')}
                    // register={register("price",
                    // {
                    // onChange: (event) => {
                    // const tempPricePerUnit = Number.parseInt(
                    //   (
                    //     Number.parseInt(event.target.value) /
                    //     getValues("bua")
                    //   ).toFixed(2)
                    // );
                    // if (
                    //   tempPricePerUnit > 0 &&
                    //   tempPricePerUnit !== "Infinity"
                    // ) {
                    // }
                    // },

                    //   required: "Please enter price.",
                    // })
                    // }
                  />
                </label>
              </div>
            )}
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="bua"
                  inputLabel={
                    <>
                      {t('BUA')} ({config?.areaUnit})
                      <span className="text-red-500">*</span>
                    </>
                  }
                  type="text"
                  onKeyDown={helpers.NumberInputWithDotNew}
                  register={register('bua', {
                    required: 'Please enter BUA.',
                    minLength: {
                      value: 2,
                      message: 'Minimum length must be 2.',
                    },
                    onChange: (event) => {
                      const tempPricePerUnit = Number.parseFloat(
                        (
                          getValues('price') /
                          Number.parseFloat(event.target.value)
                        ).toFixed(2)
                      );
                      if (
                        tempPricePerUnit > 0 &&
                        tempPricePerUnit !== 'Infinity'
                      ) {
                        setValue('pricePerUnit', tempPricePerUnit);
                      }
                    },
                  })}
                  errors={errors}
                />

                {/* {
                    config.country === 'UAE' && (   <OInputField
                      wrapperClassName="relative z-0 w-full group"
                      name="bua"
                      inputLabel={
                          <>
                              {t('BUA')} ({config?.areaUnit})
                              <span className="text-red-500">
                                  *
                              </span>
                          </>
                      }
                      type="number"
                      register={register('bua', {
                          required: 'Please enter BUA.',
                          minLength: {
                              value: 2,
                              message:
                                  'Minimum length must be 2.',
                          },
                          onChange: (event) => {
                              const tempPricePerUnit =
                                  Number.parseInt(
                                      (
                                          getValues('price') /
                                          Number.parseInt(
                                              event.target.value
                                          )
                                      ).toFixed(2)
                                  );
                              if (
                                  tempPricePerUnit > 0 &&
                                  tempPricePerUnit !== 'Infinity'
                              ) {
                                  setValue(
                                      'pricePerUnit',
                                      tempPricePerUnit
                                  );
                              }
                          },
                          validate: (value) =>
                              value?.trim()
                                  ? true
                                  : 'White spaces not allowed.',
                      })}
                      errors={errors}
                  />)
                  } */}
              </label>
            </div>
            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0  w-full group"
                  name="parking"
                  inputLabel={
                    <>
                      {t('Parking')}
                      {/* <span className='text-red-500'>*</span> */}
                    </>
                  }
                  type="text"
                  register={register('parking', {
                    // ...formValidation.parking,
                  })}
                  errors={errors}
                />
              </label>
            </div>
            {/* <div className='mb-3 '>
              <label className='block'>
                <OInputField
                  wrapperClassName='relative z-0  w-full group'
                  name='parkingAr'
                  inputLabel={<>{t('Parking') + t('O_ARABIC')}</>}
                  type='text'
                  register={register('parkingAr')}
                  errors={errors}
                />
              </label>
            </div> */}
            {config?.country === 'UAE' && (
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="advertType"
                    inputLabel={
                      <>
                        {t('ADVERT_TYPE')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="text"
                    register={register('advertType', {
                      // required: 'Please enter advert type.',
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            )}

            {/* <div className='mb-3'>
              <label className='block'>
                <OInputField
                  wrapperClassName='relative z-0   w-full group'
                  name='advertTypeAr'
                  inputLabel={
                    <>
                      {t('ADVERT_TYPE') + t('O_ARABIC')}
                    </>
                  }
                  type='text'
                  register={register('advertTypeAr', {
                    // required: 'Please enter advert type in arabic.',
                  })}
                  errors={errors}
                />
              </label>
            </div> */}
            {config.country === 'Saudi' && (
              <>
                <div className="mb-3 ">
                  <label className="block">
                    <OSelect
                      wrapperClassName="relative z-0  w-full group"
                      name="layoutType"
                      inputLabel={
                        <>
                          {t('LAYOUT_TYPE')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type="select"
                      options={propertyFaces}
                      selected={editProperty?.layoutType ?? ''}
                      defaultValue={t('Select Layout Type')}
                      register={register(
                        'layoutType',
                        // formValidation.layoutType
                        {
                          onChange: (event) => {
                            const value = event.target.value;
                            const key = propertyFaces.find(
                              (res) => res.value === value
                            );

                            if (key) {
                              setValue('layoutTypeAr', key[`keyAr`]);
                            }
                          },
                        }
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3 ">
                  <label className="block">
                    <OSelect
                      wrapperClassName="relative z-0  w-full group"
                      name="layoutTypeAr"
                      disabled
                      inputLabel={
                        <>
                          {t('LAYOUT_TYPE') + t('O_ARABIC')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type="select"
                      options={propertyFacesAr}
                      selected={editProperty?.layoutTypeAr ?? ''}
                      defaultValue={t('Select Layout Type')}
                      register={register(
                        'layoutTypeAr'
                        // formValidation.layoutTypeAr
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
              </>
            )}
            {config.country === 'UAE' && (
              <>
                <div className="mb-3 ">
                  <label className="block">
                    <OSelect
                      wrapperClassName="relative z-0  w-full group"
                      name="layoutType"
                      inputLabel={
                        <>
                          {t('LAYOUT_TYPE')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type="select"
                      options={layoutOption}
                      selected={editProperty?.layoutType ?? ''}
                      defaultValue={t('Select Layout Type')}
                      register={register(
                        'layoutType',
                        // formValidation.layoutType
                        {
                          onChange: (event) => {
                            const value = event.target.value;
                            if (value === 'Facing North') {
                              setValue('layoutTypeAr', 'مواجهة الشمال');
                            } else if (value === 'Facing West') {
                              setValue('layoutTypeAr', 'مواجهة الغرب');
                            } else if (value === 'Facing East') {
                              setValue('layoutTypeAr', 'مواجهة الشرق');
                            } else if (value === 'Facing South') {
                              setValue('layoutTypeAr', 'التي تواجه الجنوب');
                            } else {
                              setValue('layoutTypeAr', '');
                            }
                          },
                        }
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3 ">
                  <label className="block">
                    <OSelect
                      wrapperClassName="relative z-0  w-full group"
                      name="layoutTypeAr"
                      disabled
                      inputLabel={
                        <>
                          {t('LAYOUT_TYPE') + t('O_ARABIC')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type="select"
                      options={layoutOptionAr}
                      selected={editProperty?.layoutTypeAr ?? ''}
                      defaultValue={t('Select Layout Type')}
                      register={register(
                        'layoutTypeAr'
                        // formValidation.layoutTypeAr
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
              </>
            )}

            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="totalFloors"
                  inputLabel={
                    <>
                      {t('NO_OF_FLOORS')}
                      {/* <span className='text-red-500'>*</span> */}
                    </>
                  }
                  type="number"
                  register={register('totalFloors', {
                    // required: 'Please enter no. of floors.',
                  })}
                  errors={errors}
                />
              </label>
            </div>

            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="floorNumber"
                  inputLabel={
                    <>
                      {t('FLOOR_NUMBER')}
                      {/* <span className='text-red-500'>*</span> */}
                    </>
                  }
                  type="number"
                  register={register('floorNumber', {
                    // required: 'Please enter floor number.',
                  })}
                  errors={errors}
                />
              </label>
            </div>

            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="permitNumber"
                  inputLabel={
                    <>
                      {t('PERMIT_NUMBER')}
                      <span className="text-red-500">*</span>
                    </>
                  }
                  type="text"
                  register={register(
                    'permitNumber',
                    formValidation.permitNumber
                  )}
                  errors={errors}
                />
              </label>
            </div>

            <div className="mb-3 ">
              <OSelect
                wrapperClassName="relative z-0  w-full group"
                name="parkingType"
                inputLabel={
                  <>
                    {t('SELECT_PARKING_TYPE')}
                    {/* <span className='text-red-500'>*</span> */}
                  </>
                }
                type="select"
                options={parkingTypeOption}
                selected={editProperty?.parkingType ?? ''}
                defaultValue={t('SELECT_PARKING_TYPE')}
                register={register('parkingType')} //, formValidation.parkingType
                // errors={errors}
              />
            </div>

            <div className="mb-3 ">
              <OSelect
                wrapperClassName="relative z-0  w-full group"
                name="furnished"
                inputLabel={
                  <>
                    {t('FURNISHING_TYPE')}
                    {/* <span className='text-red-500'>*</span> */}
                  </>
                }
                type="select"
                options={furnishedOption}
                defaultValue={t('SELECT_FURNITURE')}
                selected={editProperty?.furnished ?? ''}
                register={register('furnished')} //, formValidation.furnished
                errors={errors}
              />
            </div>
            {(type === 'Buy' || type === 'Commercial Buy') && (
              <>
                <div className="mb-3">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="pricePerUnit"
                    step="any"
                    inputLabel={
                      <>
                        {config?.country === 'Saudi'
                          ? t('PRICE_PER_SQUARE_METER')
                          : t('PRICE_PER_SQRT')}{' '}
                        ({config?.currency})
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="number"
                    register={register('pricePerUnit', {
                      // ...formValidation.pricePerUnit,
                      onChange: (e) => preventDecimalAfterTwoDigit(e),
                    })}
                  />
                </div>
                <div className="mb-3">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="serviceCharge"
                    inputLabel={
                      <>
                        {t('SERVICE_CHARGE')} ({config?.currency})
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="number"
                    register={register('serviceCharge', {
                      // ...formValidation.serviceCharge,
                    })}
                    errors={errors}
                  />
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="financialStatus"
                    inputLabel={
                      <>
                        {t('SELECT_FINANCIAL_STATUS')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="select"
                    options={financialStatusOption}
                    selected={editProperty?.financialStatus ?? ''}
                    defaultValue={t('SELECT_FINANCIAL_STATUS')}
                    register={register('financialStatus')}
                    // , formValidation.financialStatus)}
                    errors={errors}
                  />
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="projectStatus"
                    selected={editProperty?.projectStatus ?? ''}
                    inputLabel={
                      <>
                        {t('SELECT_PROJECT_STATUS')}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="select"
                    options={statusOption}
                    defaultValue={t('SELECT_PROJECT_STATUS')}
                    register={register(
                      'projectStatus',
                      formValidation.projectStatus
                    )}
                    errors={errors}
                  />
                </div>
              </>
            )}

            {(type === 'Rent' || type === 'Commercial Rent') && (
              <>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="stage"
                    inputLabel={
                      <>
                        {t('SELECT_STAGE')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="select"
                    options={stageOption}
                    selected={editProperty?.stage ?? ''}
                    defaultValue={t('SELECT_STAGE')}
                    register={register('stage')} //  formValidation.stage
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="cheques"
                    inputLabel={
                      <>
                        {t('SELECT_CHEQUES')}
                        {/* <span className="text-red-500">*</span> */}
                      </>
                    }
                    type="select"
                    options={chequesOption}
                    selected={editProperty?.cheques ?? ''}
                    defaultValue={t('SELECT_CHEQUES')}
                    register={register(
                      'cheques'
                      // formValidation.cheques
                    )}
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="securityDeposit"
                      inputLabel={
                        <>
                          {t('SECURITY_DEPOSITS')}
                          {/* <span className="text-red-500">*</span> */}
                        </>
                      }
                      type="number"
                      register={register(
                        'securityDeposit'
                        // formValidation.securityDeposit
                      )}
                      errors={errors}
                    />
                  </label>
                </div>

                <div className="mb-3">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="priceDaily"
                    inputLabel={
                      <>
                        {t('DAILY_PRICE')} ({config?.currency})
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="number"
                    register={register('priceDaily', {
                      // ...formValidation.priceDaily,
                    })}
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="priceWeekly"
                    inputLabel={
                      <>
                        {t('WEEKLY_PRICE')} ({config?.currency})
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="number"
                    register={register('priceWeekly', {
                      // ...formValidation.priceWeekly,
                    })}
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="priceMonthly"
                    inputLabel={
                      <>
                        {t('MONTHLY_PRICE')} ({config?.currency})
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="number"
                    register={register('priceMonthly', {
                      // ...formValidation.priceMonthly,
                    })}
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="priceYearly"
                    inputLabel={
                      <>
                        {t('YEARLY_PRICE')} ({config?.currency})
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type="number"
                    register={register('priceYearly', {
                      // ...formValidation.priceYearly,
                    })}
                    errors={errors}
                  />
                </div>
              </>
            )}

            {(type === 'Commercial Buy' || type === 'Commercial Rent') && (
              <div className="mb-3 ">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="readyStage"
                  inputLabel={
                    <>
                      {t('SELECT_READY_STAGE')}
                      <span className="text-red-500">*</span>
                    </>
                  }
                  type="select"
                  options={readyStageOption}
                  selected={editProperty?.readyStage ?? ''}
                  defaultValue={t('SELECT_READY_STAGE')}
                  register={register('readyStage', formValidation.readyStage)}
                  errors={errors}
                />
              </div>
            )}

            {isAuctionProperty && (
              <>
                <div className="mb-3">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="biddingFees"
                    inputLabel={
                      <>
                        {t('O_BIDDING_FEES')}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="number"
                    register={register('biddingFees', {
                      required: 'Please enter bidding fees.',
                    })}
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <div className="relative z-0   w-full group">
                    <ODateTimePicker
                      name="auctionStartDate"
                      placeholder={t('O_AUCTION_START_DATE')}
                      value={auctionStartDate}
                      handleAuctionStartDate={handleAuctionStartDate}
                      inputLabel={
                        <>
                          {t('O_AUCTION_START_DATE')}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      startDate={auctionStartDate}
                    />
                    {isStartDateError && (
                      <ErrorMessage message="Please select auction start date." />
                    )}
                  </div>
                </div>

                <div className="mb-3">
                  <div className="relative z-0   w-full group">
                    <ODateTimePicker
                      placeholder={t('O_AUCTION_END_DATE')}
                      name="auctionEndDate"
                      value={auctionEndDate}
                      handleAuctionEndDate={handleAuctionEndDate}
                      inputLabel={
                        <>
                          {t('O_AUCTION_END_DATE')}
                          <span className="text-red-500">*</span>
                        </>
                      }
                    />
                    {isEndDateError && (
                      <ErrorMessage message="Please select auction end date." />
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="mb-3">
              <OInputField
                wrapperClassName="relative z-0 w-full group"
                name="owner_name"
                inputLabel={
                  <>
                    {t('OWNER_NAME')}
                    {/* <span className="text-red-500">*</span> */}
                  </>
                }
                type="text"
                register={register('owner_name', formValidation.owner_name)}
                errors={errors}
              />
            </div>
            <div className="mb-3">
              <OInputField
                wrapperClassName="relative z-0 w-full group"
                name="owner_email"
                inputLabel={
                  <>
                    {t('OWNER_EMAIL')}
                    {/* <span className='text-red-500'>*</span> */}
                  </>
                }
                type="email"
                register={register('owner_email', formValidation.owner_email)}
                errors={errors}
              />
            </div>
            <div className="mb-3">
              <OInputField
                wrapperClassName="relative z-0 w-full group"
                name="owner_phone"
                inputLabel={
                  <>
                    {t('OWNER_PHONE')}
                    {/* <span className="text-red-500">*</span> */}
                  </>
                }
                type="text"
                register={register('owner_phone', formValidation.owner_phone)}
                errors={errors}
              />
            </div>
            <div className="mb-3 ">
              <OSelect
                wrapperClassName="relative z-0  w-full group"
                name="agreementStatus"
                selected={editProperty?.agreementStatus ?? ''}
                inputLabel={
                  <>
                    {t('SELECT_AGREEMENT_STATUS')}
                    {/* <span className='text-red-500'>*</span> */}
                  </>
                }
                type="select"
                options={agreementStatusOption}
                defaultValue={t('SELECT_AGREEMENT_STATUS')}
                register={register('agreementStatus')}
                errors={errors}
              />
            </div>
            <div className="mb-3 ">
              <OSelect
                wrapperClassName="relative z-0  w-full group"
                name="propertyPlanId"
                selected={editProperty?.propertyPlanId ?? ''}
                inputLabel={
                  <>
                    {t('SELECT_PROPERTY_PLAN')}
                    {/* <span className='text-red-500'>*</span> */}
                  </>
                }
                type="select"
                options={availablPlans}
                defaultValue={t('SELECT_PROPERTY_PLAN')}
                register={register('propertyPlanId')}
                errors={errors}
              />
            </div>

            <div className="mb-3 ">
              <ODatePicker
                name="agreementData"
                placeholder={t('AGREEMENT_DATE')}
                handleDateChange={(date) => setAgreementDate(date)}
                value={agreementDate}
                inputLabel={<>{t('AGREEMENT_DATE')}</>}
                startDate={new Date()}
              />
            </div>
            {/* <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="cost"
                    inputLabel={<>{t("O_PRICE")}</>}
                    type="number"
                    // register={register("cost")}
                    errors={errors}
                    step="any"
                    value={taxPrice.cost}
                    onChange={(e) =>
                      setTaxPrice({ ...taxPrice, cost: e.target.value })
                    }
                  />
                </label>
              </div> */}

            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="propertyTaxPercentage"
                  inputLabel={t('PROPERTY_TAX_PER')}
                  type="number"
                  step="any"
                  value={taxPrice.propertyTaxPercentage}
                  onChange={(e) =>
                    handleInputChange('propertyTaxPercentage', e.target.value)
                  }
                />
              </label>
            </div>
            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  disabled
                  wrapperClassName="relative z-0 w-full group"
                  name="propertyTax"
                  inputLabel={t('PROPERTY_TAX')}
                  type="number"
                  step="any"
                  value={taxPrice.propertyTax}
                />
              </label>
            </div>

            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="commissionPercentage"
                  inputLabel={t('COMMISSION_PER')}
                  type="number"
                  errors={errors}
                  value={taxPrice.commissionPercentage}
                  step="any"
                  onChange={(e) =>
                    handleInputChange('commissionPercentage', e.target.value)
                  }
                />
              </label>
            </div>
            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  disabled
                  wrapperClassName="relative z-0 w-full group"
                  name="commission"
                  inputLabel={t('COMMISSION')}
                  type="number"
                  errors={errors}
                  value={taxPrice.commission}
                  step="any"
                />
              </label>
            </div>
            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0 w-full group"
                  name="commissionTaxPercentage"
                  inputLabel={t('COMMISSION_TAX_PER')}
                  type="number"
                  errors={errors}
                  value={taxPrice.commissionTaxPercentage}
                  step="any"
                  onChange={(e) =>
                    handleInputChange('commissionTaxPercentage', e.target.value)
                  }
                />
              </label>
            </div>
            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  disabled
                  wrapperClassName="relative z-0 w-full group"
                  name="commissionTax"
                  inputLabel={t('COMMISSION_TAX')}
                  type="number"
                  errors={errors}
                  value={taxPrice.commissionTax}
                  step="any"
                />
              </label>
            </div>

            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="totalArea"
                  inputLabel={<>{t('O_TOTAL_AREA')}</>}
                  type="number"
                  register={register('totalArea')}
                  errors={errors}
                  step="any"
                />
              </label>
            </div>
            <div className="mb-3 ">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="licenseNumber"
                  inputLabel={<>{t('LICENSE_NUMBER')}</>}
                  type="number"
                  register={register('licenseNumber')}
                  errors={errors}
                  step="any"
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="appBrochure"
                  inputLabel="App Brochure"
                  type="text"
                  register={register('appBrochure')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="url360"
                  inputLabel="360 URL"
                  type="text"
                  register={register('url360')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('O_SELECT_PAYMENT')}
              </p>
              <OMultiSelect
                wrapperClassName="relative mb-6 w-full group"
                name="paymentOptions "
                placeholder={
                  <>
                    {t('O_SELECT_PAYMENT')}
                    <span className="text-red-500">*</span>
                  </>
                }
                options={paymentOptionsArray}
                defaultValue={t('O_SELECT_PAYMENT')}
                onChange={setPaymentOption}
                value={paymentOptions}
              />
            </div>
            {config?.country === 'Saudi' && (
              <>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="adLinkInPlatform"
                      inputLabel={
                        <>
                          Ad Link in Platform
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('adLinkInPlatform', {
                        required: {
                          value: true,
                          message: 'Please enter ad link in platform.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="adLicenseNumber"
                      inputLabel={
                        <>
                          Ad License Number
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('adLicenseNumber', {
                        required: {
                          value: true,
                          message: 'Please enter ad license number.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="titleDeedNumber"
                      inputLabel={
                        <>
                          Title Deed Number
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('titleDeedNumber', {
                        required: {
                          value: true,
                          message: 'Please enter title deed number.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <div className="relative z-0   w-full group">
                    <ODateTimePicker
                      name="creationDate"
                      placeholder={'Select Creation Date'}
                      value={creationDate}
                      handleDateChange={setCreationDate}
                      inputLabel={
                        <>
                          Creation Date
                          <span className="text-red-500">*</span>
                        </>
                      }
                      startDate={creationDate}
                    />

                    <ErrorMessage message={errors?.creationDate} />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="relative z-0   w-full group">
                    <ODateTimePicker
                      name="endDate"
                      placeholder={'Select End Date'}
                      value={endDate}
                      handleDateChange={setEndDate}
                      inputLabel={
                        <>
                          End Date
                          <span className="text-red-500">*</span>
                        </>
                      }
                      startDate={endDate}
                    />

                    <ErrorMessage message={errors?.endDate} />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="advertiserId"
                      inputLabel={
                        <>
                          Advertiser ID
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('advertiserId', {
                        required: {
                          value: true,
                          message: 'Please enter advertiser ID.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>

                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="advertiserName"
                      inputLabel={
                        <>
                          Advertiser Name
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('advertiserName', {
                        required: {
                          value: true,
                          message: 'Please enter advertiser name.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="advertiserNameAr"
                      inputLabel={
                        <>
                          Advertiser Name {t('O_ARABIC')}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('advertiserNameAr', {
                        required: {
                          value: true,
                          message: 'Please enter advertiser name in arabic.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="advertiserMobile"
                      inputLabel={
                        <>
                          Advertiser Mobile
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('advertiserMobile', {
                        required: {
                          value: true,
                          message: 'Please enter advertiser mobile.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Channels
                  </p>
                  <OMultiSelect
                    wrapperClassName="relative mb-6 w-full group"
                    name="channels"
                    placeholder={
                      <>
                        Select Channels
                        <span className="text-red-500">*</span>
                      </>
                    }
                    options={channels}
                    onChange={handleChannelChange}
                    value={selectedChannel}
                  />
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="adLicenseUrl"
                      inputLabel={
                        <>
                          Ad License Url
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('adLicenseUrl', {
                        required: {
                          value: true,
                          message: 'Please enter ad license url.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Property Utilities
                  </p>
                  <OMultiSelect
                    wrapperClassName="relative mb-6 w-full group"
                    name="channels"
                    placeholder={
                      <>
                        Select Property Utilities
                        <span className="text-red-500">*</span>
                      </>
                    }
                    options={propertyUtilities}
                    onChange={handlePropertyUtilitiesChange}
                    value={selectedPropertyUtilities}
                  />
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="adType"
                    inputLabel={
                      <>
                        Ad Type
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="select"
                    options={adTypes}
                    defaultValue={'Select Ad Type'}
                    selected={editProperty?.furnished ?? ''}
                    register={register('adType', {
                      required: {
                        message: 'Please select ad type.',
                        value: true,
                      },
                    })} //, formValidation.furnished
                    errors={errors}
                  />
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="isConstrained"
                    inputLabel={
                      <>
                        Is Constrained
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="select"
                    options={isConstrainedOptions}
                    defaultValue={'Select Is Constrained'}
                    register={register('isConstrained', {
                      required: {
                        message: 'Please select is constrained.',
                        value: true,
                      },
                    })} //, formValidation.furnished
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="adSource"
                      inputLabel={
                        <>
                          Ad Source
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('adSource', {
                        required: {
                          value: true,
                          message: 'Please enter ad source.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group"
                      name="adSourceAr"
                      inputLabel={
                        <>
                          Ad Source {t('O_ARABIC')}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      type="text"
                      register={register('adSourceAr', {
                        required: {
                          value: true,
                          message: 'Please enter ad source in arabic.',
                        },
                      })}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="brokerageAndMarketingLicenseNumber"
                      inputLabel={'Brokerage And Marketing License No.'}
                      type="text"
                      register={register('brokerageAndMarketingLicenseNumber')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Property Usages
                  </p>
                  <OMultiSelect
                    wrapperClassName="relative mb-6 w-full group"
                    name="propertyUsages"
                    placeholder={<>Select Property Usages</>}
                    options={propertyUsages}
                    onChange={handlePropertyUsageChange}
                    value={selectedPropertyUsages}
                  />
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="propertyAge"
                    inputLabel={<>Property Age</>}
                    type="select"
                    options={propertyAge}
                    defaultValue={'Select Property Age'}
                    register={register('propertyAge', {})} //, formValidation.furnished
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="obligationsOnTheProperty"
                      inputLabel="Obligations On The Property"
                      type="text"
                      register={register('obligationsOnTheProperty')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="guaranteesAndTheirDuration"
                      inputLabel="Guarantees And Their Duration"
                      type="text"
                      register={register('guaranteesAndTheirDuration')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="planNumber"
                      inputLabel="Plan Number"
                      type="text"
                      register={register('planNumber')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="landNumber"
                      inputLabel="Land Number"
                      type="text"
                      register={register('landNumber')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="complianceWithTheSaudiBuildingCode"
                    inputLabel={<>Compliance With The Saudi Building Code</>}
                    type="select"
                    options={complianceWithTheSaudiBuildingCodeOptions}
                    defaultValue={
                      'Select Compliance With The Saudi Building Code'
                    }
                    register={register(
                      'complianceWithTheSaudiBuildingCode',
                      {}
                    )} //, formValidation.furnished
                    errors={errors}
                  />
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="titleDeedType"
                    inputLabel={<>Title Deed Type</>}
                    type="select"
                    options={titleDeedTypes}
                    defaultValue={'Select Title Deed Type'}
                    register={register('titleDeedType', {})} //, formValidation.furnished
                    errors={errors}
                  />
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="landTotalPrice"
                      inputLabel="Land Total Price"
                      type="number"
                      register={register('landTotalPrice')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="totalAnnualRentForTheLand"
                      inputLabel="Total Annual Rent For The Land"
                      type="number"
                      register={register('totalAnnualRentForTheLand')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="notes"
                      inputLabel="Notes"
                      type="text"
                      register={register('notes')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="notesAr"
                      inputLabel={'Notes' + t('O_ARABIC')}
                      type="text"
                      register={register('notesAr')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="locationDescriptionAccordingToDeed"
                      inputLabel={'Location Description According To Deed'}
                      type="text"
                      register={register('locationDescriptionAccordingToDeed')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3">
                  <label className="block">
                    <OInputField
                      wrapperClassName="relative z-0   w-full group "
                      name="locationDescriptionAccordingToDeedAr"
                      inputLabel={
                        'Location Description Accor...' + t('O_ARABIC')
                      }
                      type="text"
                      register={register(
                        'locationDescriptionAccordingToDeedAr'
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="isConstrained"
                    inputLabel={
                      <>
                        Main Land Use Type Name
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="select"
                    options={mainLandUseTypeNames}
                    defaultValue={'Select Main Land Use Type Name'}
                    register={register('mainLandUseTypeName', {
                      required: {
                        message: 'Please select Main Land Use Type Name.',
                        value: true,
                      },
                    })} //, formValidation.furnished
                    errors={errors}
                  />
                </div>
                <div className="mb-3 ">
                  <OSelect
                    wrapperClassName="relative z-0  w-full group"
                    name="isConstrained"
                    inputLabel={
                      <>
                        Red Zone Type Name
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="select"
                    options={redZoneTypeNames}
                    defaultValue={'Select Red Zone Type Name'}
                    register={register('redZoneTypeName', {
                      required: {
                        message: 'Please select Red Zone Type Name.',
                        value: true,
                      },
                    })} //, formValidation.furnished
                    errors={errors}
                  />
                </div>
              </>
            )}
          </div>

          <h4 className="text-lg font-semibold py-3">Nearest Facility App</h4>
          {nearestFacilityApp?.length > 0 &&
            nearestFacilityApp?.map((item, index) => {
              return (
                <div
                  className="flex gap-4 xl:gap-12  w-auto inline-block px-3 mb-2 rounded-sm"
                  key={index}
                >
                  <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/2">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        Name
                      </span>
                      <input
                        type="text"
                        name="name"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        // placeholder={t('O_TITLE')}
                        value={item?.name}
                        onChange={(e) => {
                          setNearestFacilityApp(
                            nearestFacilityApp?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  name: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </label>
                  </div>
                  <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/2">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        Distance
                      </span>
                      <input
                        type="text"
                        name="distance"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        // placeholder={t('O_TITLE')}
                        value={item?.distance}
                        onChange={(e) => {
                          setNearestFacilityApp(
                            nearestFacilityApp?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  distance: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </label>
                  </div>
                  <div className="flex items-center">
                    <button
                      type="button"
                      className="ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]"
                      onClick={() => deleteMore('nearestFacilityApp', index)}
                    >
                      <span className=" text-[#222]  text-lg " title="Close">
                        ×
                      </span>
                    </button>
                  </div>
                </div>
              );
            })}
          <button
            className="text-blue-400"
            type="button"
            onClick={() => addMoreNearestFacilityApp()}
          >
            {t('ADD')}
          </button>

          <h4 className="text-lg font-semibold py-3">
            Nearest Facility App (Arbic)
          </h4>
          {nearestFacilityAppAr?.length > 0 &&
            nearestFacilityAppAr?.map((item, index) => {
              return (
                <div
                  className="flex gap-4 xl:gap-12  w-auto inline-block px-3 mb-2 rounded-sm"
                  key={index}
                >
                  <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/2">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        Name
                      </span>
                      <input
                        type="text"
                        name="name"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        // placeholder={t('O_TITLE')}
                        value={item?.name}
                        onChange={(e) => {
                          setNearestFacilityAppAr(
                            nearestFacilityAppAr?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  name: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </label>
                  </div>
                  <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/2">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        Distance
                      </span>
                      <input
                        type="text"
                        name="distance"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        // placeholder={t('O_TITLE')}
                        value={item?.distance}
                        onChange={(e) => {
                          setNearestFacilityAppAr(
                            nearestFacilityAppAr?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  distance: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </label>
                  </div>
                  <div className="flex items-center">
                    <button
                      type="button"
                      className="ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]"
                      onClick={() => deleteMore('nearestFacilityAppAr', index)}
                    >
                      <span className=" text-[#222]  text-lg " title="Close">
                        ×
                      </span>
                    </button>
                  </div>
                </div>
              );
            })}

          <button
            className="text-blue-400"
            type="button"
            onClick={() => addMoreNearestFacilityApp('ar')}
          >
            {t('ADD')}
          </button>

          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              {/* <OTextArea
                wrapperClassName='relative z-0 my-6 w-full group'
                name='description'
                inputLabel={<>{t('O_DESCRIPTION')}</>}
                type='textarea'
                register={register('description')}
              /> */}

              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('OFFERS_DESCRIPTION')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={description}
                  onChange={setDescription}
                />
              </div>
            </div>
            <div className="mb-3">
              {/* <OTextArea
                wrapperClassName='relative z-0 my-6 w-full group'
                name='descriptionAr'
                inputLabel={
                  <>
                    {t('O_DESCRIPTION') + t('O_ARABIC')}

                  </>
                }
                type='textarea'
                register={register('descriptionAr')}
                errors={errors}
              /> */}
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('OFFERS_DESCRIPTION') + t('O_ARABIC')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={descriptionAr}
                  onChange={setDescriptionAr}
                />
              </div>
            </div>
          </div>
          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="metaTitle"
                  inputLabel={t('STATIC_TITLE')}
                  type="text"
                  register={register('metaTitle')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="metaTitleAr"
                  inputLabel={
                    <>
                      {t('STATIC_TITLE')} {t('O_ARABIC')}
                    </>
                  }
                  type="text"
                  register={register('metaTitleAr')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OTextArea
                  wrapperClassName="relative z-0   w-full group"
                  name="metaDescription"
                  inputLabel={t('STATIC_DESCRIPTION')}
                  type="text"
                  register={register('metaDescription')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OTextArea
                  wrapperClassName="relative z-0 w-full group"
                  name="metaDescriptionAr"
                  inputLabel={
                    <>
                      {t('STATIC_DESCRIPTION')} {t('O_ARABIC')}
                    </>
                  }
                  type="text"
                  register={register('metaDescriptionAr')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OTextArea
                  wrapperClassName="relative z-0 w-full group"
                  name="keyword"
                  inputLabel={t('KEYWORD')}
                  type="text"
                  register={register('keyword')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OTextArea
                  wrapperClassName="relative z-0 w-full group"
                  name="keywordAr"
                  inputLabel={
                    <>
                      {t('KEYWORD')} {t('O_ARABIC')}
                    </>
                  }
                  type="text"
                  register={register('keywordAr')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Is Mortgage Available
              </p>
              <label
                className="inline-flex relative items-center cursor-pointer"
                title="Is Mortgage Available"
                // title={`${
                //   item?.status === 'yes' ? 'Yes' : 'No'
                // }`}
              >
                <input
                  type="checkbox"
                  // value="yes"
                  className="sr-only peer"
                  checked={isMortgageAvailable}
                  id="isMortgageAvailable"
                  name="isMortgageAvailable"
                  onChange={(e) => setIsMortgageAvailable(e.target.checked)}
                />
                <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
              </label>
            </div>
          </div>
          <h4 className="text-lg font-semibold py-3">Bank Details</h4>
          <div>
            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="accountName"
                    inputLabel={<>{t('ACCOUNT_NAME')}</>}
                    type="text"
                    register={register('accountName')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="accountNameAr"
                    inputLabel={
                      <>
                        {t('ACCOUNT_NAME')} {t('O_ARABIC')}
                      </>
                    }
                    type="text"
                    register={register('accountNameAr')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="bankName"
                    inputLabel={<>{t('BANK_NAME')}</>}
                    type="text"
                    register={register('bankName')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="bankNameAr"
                    inputLabel={
                      <>
                        {t('BANK_NAME')} {t('O_ARABIC')}
                      </>
                    }
                    type="text"
                    register={register('bankNameAr')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="iban"
                    inputLabel={<>{t('IBAN')}</>}
                    type="text"
                    register={register('iban')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="downPaymentPercentage"
                    inputLabel={<>{t('DOWN_PAYMENT_PERCENTAGE')}</>}
                    type="text"
                    register={register('downPaymentPercentage', {
                      pattern: {
                        value: /^\d*\.?\d*$/,
                        message:
                          'Only numbers and one decimal point are allowed',
                      },
                      setValueAs: (value) =>
                        value === '' ? undefined : parseFloat(value), // convert to number
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="border-t mt-10 py-10 text-center">
            <button
              type="submit"
              className="bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
            >
              {t('SAVE_&_CONTINUE')}
            </button>
          </div>
          {/* </div> */}
        </form>
      </div>
      {isAmenities && (
        <OAmenities
          propertyAmenitiesList={propertyAmenitiesList}
          setIsAmenities={setIsAmenities}
          setPropertyAmenities={setPropertyAmenities}
          propertyAmenities={propertyAmenities}
          setIsAmenity={setIsAmenity}
        />
      )}
      {isPropertyCategories && (
        <OPropertyCategories
          propertyCategoryTypes={propertyCategoryTypes}
          setIsPropertyCategories={setIsPropertyCategories}
          propertyCategoryType={propertyCategoryType}
          handleCategoryChangeType={handleCategoryChangeType}
          propertyType={propertyType}
        />
      )}
      {isAgentModalOpen && (
        <AgentListModal
          setIsAgentModalOpen={setIsAgentModalOpen}
          setSelected={setSelected}
          selected={selected}
          setIsAgentNameValid={setIsAgentNameValid}
        />
      )}
    </>
  );
};

export default BasicInformation;
